// Strapi returns media `url` as a path relative to the Strapi host
// (e.g. `/uploads/logo.svg`). For browser-side rendering the server-side
// Strapi URL (which may be a Docker hostname like `node-server:3000`) is
// unreachable, so we prepend `strapi.publicUrl` instead.
// Shared `sizes`/`imagesizes` for hero media (card poster + hero image): roughly
// half-width on desktop, full-width on mobile — keeps the preload and the <img>
// picking the same responsive candidate.
export const STRAPI_IMAGE_SIZES = '(min-width: 1024px) 600px, 100vw'

export const resolveStrapiMediaUrl = (url: string, publicUrl: string): string => {
  if (/^https?:\/\//.test(url)) return url
  return `${publicUrl.replace(/\/+$/, '')}${url.startsWith('/') ? '' : '/'}${url}`
}

// Builds a `srcset` from a Strapi media's responsive formats + the original,
// deduped by width, so the browser can pick a display-sized variant instead of
// always downloading the full-size image.
export const buildStrapiSrcset = (
  media: { url: string, width?: number, formats?: Record<string, { url: string, width?: number } | null> | null } | null | undefined,
  publicUrl: string,
): string => {
  if (!media) return ''

  const byWidth = new Map<number, string>()
  const add = (url?: string, width?: number): void => {
    if (!url || !width) return
    byWidth.set(Math.round(width), resolveStrapiMediaUrl(url, publicUrl))
  }

  Object.values(media.formats ?? {}).forEach((format) => add(format?.url, format?.width))
  add(media.url, media.width)

  return [...byWidth.entries()]
    .sort(([a], [b]) => a - b)
    .map(([width, url]) => `${url} ${width}w`)
    .join(', ')
}